import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PricingCalculator from "../PricingCalculator";
import { useSite } from "../../context/SiteContext";
import { useCurrency } from "../../context/CurrencyContext";

export default function PricingSection() {
  const { settings } = useSite();
  const { money } = useCurrency();
  const r = settings.rates;

  return (
    <section className="py-24 lg:py-36 border-t border-white/5 bg-navy-900/50" data-testid="pricing-section">
      <div className="container-x">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6">
          <div>
            <p className="section-label">TRANSPARENT PRICING</p>
            <h2 className="mt-5 font-heading text-4xl sm:text-5xl font-bold tracking-tight text-white">
              KNOW THE NUMBER <span className="text-flame">BEFORE WE START.</span>
            </h2>
          </div>
          <Link to="/pricing" data-testid="pricing-section-link" className="inline-flex items-center gap-2 font-heading font-bold text-sm text-flame hover:gap-3 transition-all shrink-0">
            FULL PRICING <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="mt-10 flex flex-wrap gap-3" data-testid="pricing-rate-chips">
          <span className="rounded-full border border-white/15 px-5 py-2.5 text-xs font-semibold tracking-wider text-slate-200">STANDARD — {money(r.standard)}/hr</span>
          <span className="rounded-full border border-white/15 px-5 py-2.5 text-xs font-semibold tracking-wider text-slate-200">VIBE CODING SPECIALIST — {money(r.specialist)}/hr</span>
          <span className="rounded-full border border-flame/40 bg-flame/10 px-5 py-2.5 text-xs font-semibold tracking-wider text-flame">SUPER VIBE CODER — {money(r.super)}/hr</span>
        </div>

        <div className="mt-12">
          <PricingCalculator />
        </div>
      </div>
    </section>
  );
}
